import Addmenu from './Addmenu.vue';

export default Addmenu;



// WEBPACK FOOTER //
// ./src/components/parts/header/addmenu/index.ts